export default __webpack_public_path__ + "static/media/policyUmbrella.411208c5.svg";